import { getLocale } from "../runtime";

const sv_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska olika användningsområden för våra produkter på Happy Green`
};

const usecasesdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_usecasesdescription(inputs)
	return "useCasesDescription";
};

export { usecasesdescription as "useCasesDescription" };